import { Injectable } from '@angular/core';
import { ReplaySubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  currCurrency: ReplaySubject<any> = new ReplaySubject();

  constructor() { }

  getCurrCurrency(): Observable<any> {
    return this.currCurrency.asObservable();
  }

  setCurrCurrency(userAccount: any): void {
  
    this.currCurrency.next(userAccount);
  }

}
